import React, { useState } from 'react';
import { connect } from 'react-redux';
import CardActualizacionMasiva from "../../../General/Excel/CardActualizacionMasiva";
import MiniSpinner from '../../../General/MiniSpinner';
import {
  base64ToArrayBufferXlsx,
  saveByteArrayXlsx,
  formatFile
} from '../../../../utilities/formatFile';
import {
  postCreacionMasivaPublicacionesApi,
  fetchExportarCategoriasApi,
  fetchExportarMarcasApi
} from '../../../../api/axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const CreacionMasivaPublicaciones = ({ tipoUsuario }) => {
  const [file, setFile] = useState();
  const [isLoading, setIsLoading] = useState({
    marcas: false,
    categorias: false,
    postPublicaciones: false
  });
  const navigate = useNavigate();

  const isLoadingHandler = (name, state) => {
    setIsLoading(prevState => ({ ...prevState, [name]: state }));
  };

  const downloadXlsMarcas = () => {
    isLoadingHandler("marcas", true);

    const req = fetchExportarMarcasApi();
    req.then(res => {
      if (res.excelBase64) {
        let blob = base64ToArrayBufferXlsx(res.excelBase64);
        saveByteArrayXlsx('Marcas.xlsx', blob);
      }
      toast.success(res.message ?? "Exportación exitosa");
    }).catch(err => {
      toast.warn(err.message ?? "No se pudo descargar");
    }).finally(() => {
      isLoadingHandler("marcas", false);;
    });
  };

  const downloadXlsCategorias = () => {
    isLoadingHandler("categorias", true);

    const req = fetchExportarCategoriasApi();
    req.then(res => {
      if (res.excelBase64) {
        let blob = base64ToArrayBufferXlsx(res.excelBase64);
        saveByteArrayXlsx('Categorias SubFamilias.xlsx', blob)
      }
      toast.success(res.message ?? "Exportación exitosa");
    }).catch(err => {
      toast.warn(err.message ?? "No se pudo descargar");
    }).finally(() => {
      isLoadingHandler("categorias", false);
    });
  }

  const isValidUpdateExcel = () => {
    if (!file) {
      toast.warn('No ha seleccionado ningún archivo excel.');
      return false;
    }
    return true;
  }

    const exportExcel = async () => {
        isLoadingHandler("postPublicaciones", true);

        try {
            const excelBase64 = await formatFile(file, "xlsx");
            const res = await postCreacionMasivaPublicacionesApi({ file: excelBase64 });

            const data = res.data ?? {};
            const publicadas = data.publicacion ?? [];
            const errores = data.errors ?? [];

            //publicaciones con errores y otras creadas con éxito
            if (publicadas.length > 0 && errores.length > 0) {
                toast.success(`${publicadas.length} publicación(es) creada(s) con éxito.`);

                // Mostrar toast individual por cada publicación creada
                publicadas.forEach(pub =>
                    toast.success(`Publicación creada: ${pub.idPublicacion}`)
                );

                //las publicaciones con errores
                errores.forEach(err =>
                    toast.warn(`${err.skuSeller}: ${err.errorMesage}`)
                );

                //todas con éxito
            } else if (publicadas.length > 0 && errores.length === 0) {
                toast.success(`${publicadas.length} publicación(es) creadas con éxito.`);
                navigate("/publicaciones");

                //ninguna se creó
            } else if (publicadas.length === 0 && errores.length > 0) {
                toast.error(`Ninguna publicación se creó. (${errores.length} error(es))`);

                errores.forEach(err =>
                    toast.warn(`${err.skuSeller}: ${err.errorMesage}`)
                );
            } 

        } catch (err) {
            if (err.response?.data?.errores?.length) {
                err.response.data.errores.forEach(e => toast.warn(e));
            } else {
                toast.error("Las publicaciones no pudieron ser creadas.");
            }
        } finally {
            isLoadingHandler("postPublicaciones", false);
        }
    };

  return (
    <div className="container">
    {tipoUsuario !== 6 &&
      <div className="row justify-content-between align-items-center page-titles text-center text-md-start">

        <div className="col-12 mb-4">
          <div className="row mb-2 pb-2">

            <div className="col-12 col-md-auto align-self-center">
              <h4 className="text-themecolor color-rojo-megatone">Creación Masiva</h4>
            </div>

            <div className="col-12 p-0 ps-1 border-2 border-start d-inline-flex">
              <div className="row align-items-center">
                <label>Presione el botón Formato Excel para descargar un excel con el formato correcto, luego completelo y vuelva a importarlo.</label>
              </div>
            </div>

          </div>
        </div>

        <div className="card p-4">
          <CardActualizacionMasiva
            title="Publicaciones"
            btnText="Crear Publicaciones"
            tipoExcel={4}
            additionalHeader={(
              <div className="col-auto">
                <div className="row my-md-0 my-sm-2">

                  <div className="col-12 col-sm-auto my-2 my-sm-0"> 
                    <button
                      onClick={downloadXlsMarcas}
                      className="btn btn-sm btn-green"
                      disabled={isLoading.marcas}
                    >
                      Descargar Marcas
                    </button>
                  </div>
                  <div className="col-auto" hidden={!isLoading.marcas}>
                    <MiniSpinner />
                  </div>
                  
                  <div className="col-12 col-sm-auto my-0 my-sm-0">
                    <button
                      onClick={downloadXlsCategorias}
                      className="btn btn-sm btn-green"
                      disabled={isLoading.categorias}
                    >
                      Descargar Categorías
                    </button>
                  </div>
                  <div className="col-auto" hidden={!isLoading.categorias}>
                    <MiniSpinner />
                  </div>

                </div>
              </div>
            )}
            isLoading={isLoading.postPublicaciones}
            updateFile={setFile}
            exportExcel={exportExcel}
            isValidUpdateExcel={isValidUpdateExcel}
            downloadName="Modelo Creación Masiva de Publicaciones"
          />
        </div>

      </div>
    }
    </div>
  )
};

const mapStateToProps = (state) => ({
  tipoUsuario: state.general.tipoUsuario
});

export default connect(mapStateToProps)(CreacionMasivaPublicaciones);